import { useMemo } from 'react';
import useFetchGQLListTill from 'src/lib/graphql/hooks/useFetchGQLListTill';
import { useQuestionListForQPQuery, } from 'src/modules/exam-preparation/graphql/question/getQuestionsForQP';
export default function useQPQuestionSiblings(questionPaperID, expectedListLength) {
    const [listQueryState, listQueryActions] = useQuestionListForQPQuery({
        fetchPolicy: 'cache-first',
        nextFetchPolicy: 'cache-first',
    });
    const listQueryVariables = useMemo(() => ({
        questionPaperID,
    }), [questionPaperID]);
    const [siblingQueryState] = useFetchGQLListTill(listQueryState, listQueryActions, listQueryVariables, expectedListLength);
    const state = siblingQueryState;
    const actions = {};
    return [state, actions];
}
